import { render } from "./ExaminerHelp.vue?vue&type=template&id=964cb4da&scoped=true"
import script from "./ExaminerHelp.vue?vue&type=script&lang=js"
export * from "./ExaminerHelp.vue?vue&type=script&lang=js"

import "./ExaminerHelp.vue?vue&type=style&index=0&id=964cb4da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-964cb4da"]])

export default __exports__